import React from 'react'

import UserChangelogList from '@/components/users/screens/UserChangelogList'

export default function EmbedChangelogPage() {
  return <UserChangelogList initialChangelogs={[]} />
}
